import React from 'react';

function StatCard({ label, value, icon, borderColor, onClick, active }) {
  return (
    <button
      onClick={onClick}
      style={{
        backgroundColor: active ? 'var(--primary-light)' : 'var(--card-bg)',
        borderLeft: `3px solid ${borderColor}`,
        border: active ? `2px solid var(--primary)` : 'none',
        borderLeftWidth: '3px',
        borderLeftStyle: 'solid',
        borderLeftColor: borderColor,
        borderRadius: '4px',
        padding: '0.5rem 0.75rem',
        textAlign: 'center',
        minWidth: '100px',
        boxShadow: active ? '0 2px 8px rgba(13, 110, 253, 0.15)' : '0 1px 3px rgba(0,0,0,0.08)',
        cursor: 'pointer',
        transition: 'all 0.2s'
      }}
    >
      <div style={{ fontSize: '16px', fontWeight: '700', color: borderColor }}>
        {value}
      </div>
      <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{icon} {label}</div>
    </button>
  );
}

function TaskStats({
  stats,
  selectedCategory,
  setSelectedCategory,
  selectedStatus,
  setSelectedStatus
}) {
  if (!stats) return null;

  return (
    <div style={{
      display: 'flex',
      gap: '0.5rem',
      marginBottom: '0.75rem',
      flexWrap: 'wrap'
    }}>
      <StatCard
        label="Na dziś"
        value={stats.dzis}
        icon={'📅'}
        borderColor="var(--danger)"
        onClick={() => setSelectedCategory('dzis')}
        active={selectedCategory === 'dzis'}
      />
      <StatCard
        label="Na jutro"
        value={stats.jutro}
        icon={'📆'}
        borderColor="var(--warning)"
        onClick={() => setSelectedCategory('jutro')}
        active={selectedCategory === 'jutro'}
      />
      <StatCard
        label="Ten tydzień"
        value={stats.tydzien}
        icon={'📋'}
        borderColor="var(--info)"
        onClick={() => setSelectedCategory('tydzien')}
        active={selectedCategory === 'tydzien'}
      />
      <StatCard
        label="Zaległe"
        value={stats.zaległe || 0}
        icon={'⚠️'}
        borderColor="var(--danger)"
        onClick={() => { setSelectedCategory('wszystkie'); }}
        active={false}
      />
      <StatCard
        label="W trakcie"
        value={stats.w_trakcie}
        icon={'🔄'}
        borderColor="var(--info)"
        onClick={() => setSelectedStatus('w_trakcie')}
        active={selectedStatus === 'w_trakcie'}
      />
      <StatCard
        label="Ukończone dziś"
        value={stats.zakonczone_dzis}
        icon={'✅'}
        borderColor="var(--success)"
        onClick={() => setSelectedStatus('zakonczone')}
        active={selectedStatus === 'zakonczone'}
      />
    </div>
  );
}

export default React.memo(TaskStats);
